/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brave_Vpn_HeadingInputs */

const en_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const id_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const ms_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const ca_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN de Brave`)
};

const cs_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const da_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const de_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const et_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const es_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN de Brave`)
};

const fr_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN Brave`)
};

const hr_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const it_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN.`)
};

const lv_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const lt_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`„Brave“ VPN`)
};

const hu_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const nl_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const nb_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const pl_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const pt_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN Brave`)
};

const ro_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VPN Brave`)
};

const sk_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const sl_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const fi_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const sv_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const vi_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const tr_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const el_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const bg_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const ru_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const sr_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const uk_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const ka_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const hi_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const th_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const ko_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const zh_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const zh_tw_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

const ja_brave_vpn_heading = /** @type {(inputs: Brave_Vpn_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave VPN`)
};

/**
* | output |
* | --- |
* | "Brave VPN" |
*
* @param {Brave_Vpn_HeadingInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const brave_vpn_heading = /** @type {((inputs?: Brave_Vpn_HeadingInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brave_Vpn_HeadingInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_brave_vpn_heading(inputs)
	if (locale === "ms") return ms_brave_vpn_heading(inputs)
	if (locale === "ca") return ca_brave_vpn_heading(inputs)
	if (locale === "cs") return cs_brave_vpn_heading(inputs)
	if (locale === "da") return da_brave_vpn_heading(inputs)
	if (locale === "de") return de_brave_vpn_heading(inputs)
	if (locale === "et") return et_brave_vpn_heading(inputs)
	if (locale === "es") return es_brave_vpn_heading(inputs)
	if (locale === "fr") return fr_brave_vpn_heading(inputs)
	if (locale === "hr") return hr_brave_vpn_heading(inputs)
	if (locale === "it") return it_brave_vpn_heading(inputs)
	if (locale === "lv") return lv_brave_vpn_heading(inputs)
	if (locale === "lt") return lt_brave_vpn_heading(inputs)
	if (locale === "hu") return hu_brave_vpn_heading(inputs)
	if (locale === "nl") return nl_brave_vpn_heading(inputs)
	if (locale === "nb") return nb_brave_vpn_heading(inputs)
	if (locale === "pl") return pl_brave_vpn_heading(inputs)
	if (locale === "pt") return pt_brave_vpn_heading(inputs)
	if (locale === "ro") return ro_brave_vpn_heading(inputs)
	if (locale === "sk") return sk_brave_vpn_heading(inputs)
	if (locale === "sl") return sl_brave_vpn_heading(inputs)
	if (locale === "fi") return fi_brave_vpn_heading(inputs)
	if (locale === "sv") return sv_brave_vpn_heading(inputs)
	if (locale === "vi") return vi_brave_vpn_heading(inputs)
	if (locale === "tr") return tr_brave_vpn_heading(inputs)
	if (locale === "el") return el_brave_vpn_heading(inputs)
	if (locale === "bg") return bg_brave_vpn_heading(inputs)
	if (locale === "ru") return ru_brave_vpn_heading(inputs)
	if (locale === "sr") return sr_brave_vpn_heading(inputs)
	if (locale === "uk") return uk_brave_vpn_heading(inputs)
	if (locale === "ka") return ka_brave_vpn_heading(inputs)
	if (locale === "hi") return hi_brave_vpn_heading(inputs)
	if (locale === "th") return th_brave_vpn_heading(inputs)
	if (locale === "ko") return ko_brave_vpn_heading(inputs)
	if (locale === "zh") return zh_brave_vpn_heading(inputs)
	if (locale === "zh-tw") return zh_tw_brave_vpn_heading(inputs)
	if (locale === "ja") return ja_brave_vpn_heading(inputs)
	return en_brave_vpn_heading(inputs)
});